<template>
	<div>
		<p class="row">
			<b>{{ $t('labels.general.ok') }}</b>
			<span>{{ printBool(value.values.ok) }}</span>
		</p>
		<p class="row">
			<b>{{ $t('labels.general.sos') }}</b>
			<span>{{ printBool(value.values.sos) }}</span>
		</p>
		<p class="row">
			<b>{{ $t('labels.general.false_positive') }}</b>
			<span>{{ printBool(value.values.false_fall) }}</span>
		</p>
		<p class="row">
			<b>{{ $t('labels.general.no_response') }}</b>
			<span>{{ printBool(value.values.no_response) }}</span>
		</p>
		<!--pre>{{ value }}</pre-->
	</div>
</template>

<script>
export default {
	props: [
		'value'
	],
	methods: {
		printBool (value) {
			return value ? 'yes' : 'no'
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/watch/readings/shared/widgets/modal/ModalBoxBiometricFalls.vue